import { queryOptions, useQuery } from '@tanstack/react-query';
import { env } from 'config/env';
import { http, HttpResponse, delay } from 'msw';
import { api } from 'lib/api-client';
import { QueryConfig } from 'lib/react-query';
import { Implementation } from 'types/api';
import { createFakeImplementation } from 'mocks';

type GetImplementationResponse = {
    implementation: Implementation;
};

export const getImplementation = async (
    implementationId: string,
): Promise<Implementation> => {
    const response = await api.get<
        GetImplementationResponse,
        GetImplementationResponse
    >(`/app/api/v1/implementation/${implementationId}`);
    return response.implementation;
};

export const getImplementationQueryOptions = (implementationId: string) => {
    return queryOptions({
        queryKey: ['implementation', implementationId],
        queryFn: () => getImplementation(implementationId),
    });
};

type UseImplementationOptions = {
    implementationId: string;
    queryConfig?: QueryConfig<typeof getImplementationQueryOptions>;
};

export const useImplementation = ({
    implementationId,
    queryConfig,
}: UseImplementationOptions) => {
    return useQuery({
        ...getImplementationQueryOptions(implementationId),
        ...queryConfig,
    });
};

export const getImplementationMSWHandler = http.get(
    `${env.API_URL}/app/api/v1/implementation/:implementationId`,
    async () => {
        await delay(1000);
        return HttpResponse.json({
            implementation: createFakeImplementation({
                numImplementationCodes: Math.floor(Math.random() * 5 + 3), // random number between 3 and 5
                numPreprocessedData: Math.floor(Math.random() * 3), // random number between 0 and 3
                numTools: Math.floor(Math.random() * 3 + 1), // random number between 1 and 3
                numEvaluations: Math.floor(Math.random() * 5 + 1), // random number between 1 and 5
            }),
        });
    },
);
